module.exports = __webpack_public_path__ + "img/فانتزی (1).dbbadedb.jpg";